<template>
<div class="chapter">
<div class="inner_page">
<p class="images3"><img alt="Image" src="images/img2.jpg" style="max-width:100%;"/></p>
<p class="head">DISCOVER THE LONG-LOST SKILLS OF SELF-RELIANCE</p>
<p class="noindent_1"><span class="dropcap">M</span>y name is Caleb Warnock, and I’ve been working for years to learn how to return to forgotten skills, the skills of our ancestors. As our world becomes increasingly unstable, self-reliance becomes invaluable. Throughout this series, <em class="italic">The Backyard Renaissance</em>, I will share with you the lost skills of self-sufficiency and healthy living. Come with me and other do-it-yourself experimenters, and rediscover the joys and successes of simple self-reliance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// discover.vue?1b28d991